import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || "";

const isValid = connectionString && !connectionString.includes("REPLACE_ME");

let appInsights = null;

if (isValid && !window.location.pathname.startsWith('/pizarra/')) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      autoTrackPageVisitTime: true,
      enableAutoRouteTracking: true,
    },
  });
  appInsights.addTelemetryInitializer(() => !window.location.pathname.startsWith('/pizarra/'));
  appInsights.loadAppInsights();
}

export function initAppInsights(userId, userName) {
  if (!appInsights || !userId) return;
  appInsights.setAuthenticatedUserContext(userId, null, true);
  appInsights.trackEvent({
    name: "UserAuthenticated",
    properties: { userId, userName },
  });
}

export function trackPageView(pageName, properties = {}) {
  if (!appInsights) return;
  appInsights.trackPageView({ name: pageName, properties });
}

export function trackEvent(name, properties = {}) {
  if (!appInsights) return;
  appInsights.trackEvent({ name, properties });
}

export default appInsights;
